import { ReactNode, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { GuardiansPassportProvider } from "@/features/passport/GuardiansPassportContext"
import { BattleChallengeProvider } from "@/features/battle/BattleChallengeContext"
import { DeckChallengeProvider } from "@/features/battle/DeckChallengeContext"
import BattleReconnectGate from "@/features/battle/BattleReconnectGate"
import GameWebNotificationsBridge from "@/features/notifications/GameWebNotificationsBridge"
import CityChatUnreadBridge from "@/features/city/CityChatUnreadBridge"
import { setWebNavigate } from "@/navigation/webNavigate"

export default function PlayProviders({ children }: { children: ReactNode }) {
  const navigate = useNavigate()

  useEffect(() => {
    setWebNavigate((path) => navigate(path))
    return () => setWebNavigate(null)
  }, [navigate])

  return (
    <GuardiansPassportProvider>
      <BattleChallengeProvider>
        <DeckChallengeProvider>
          <BattleReconnectGate />
          <GameWebNotificationsBridge />
          <CityChatUnreadBridge />
          {children}
        </DeckChallengeProvider>
      </BattleChallengeProvider>
    </GuardiansPassportProvider>
  )
}
